import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const ImageSlashStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M38.6689 37.0645L37.0684 38.667L34.4014 36.001H14.3359C11.5867 36.001 9.33612 33.7502 9.33594 31.001V17.001C9.33594 15.353 10.1548 13.9047 11.3975 12.998L9.33594 10.9365L10.9395 9.33398L38.6689 37.0645ZM15.2158 24.7393C14.6971 24.2193 13.8487 24.2193 13.3301 24.7393L11.6025 26.4678V32.4004C11.6025 33.1336 12.2024 33.7342 12.9355 33.7344H24.2119L15.2158 24.7393ZM26.4609 28.0605C25.2037 28.3152 23.9795 28.6637 22.8076 29.125L27.417 33.7344H32.1348L26.4609 28.0605ZM33.6689 12.001C36.4183 12.001 38.6696 14.2513 38.6709 17.002V31.002C38.6709 31.8259 38.4491 32.5923 38.0918 33.2803L36.4023 31.5918V28.4043C35.1438 28.0537 33.8421 27.8157 32.5049 27.6943L30.1719 25.3604C30.3398 25.3577 30.5011 25.334 30.6689 25.334C32.6488 25.334 34.5638 25.5925 36.4023 26.0498V15.6006C36.4023 14.8673 35.8026 14.2676 35.0693 14.2676H19.0781L16.8115 12.001H33.6689ZM12.7119 14.3125C12.0879 14.4232 11.6026 14.9473 11.6025 15.6006V23.4424C13.5332 22.2237 16.129 22.4463 17.8076 24.125L21.0439 27.3604C22.1706 26.8644 23.3509 26.4731 24.5615 26.1611L12.7119 14.3125ZM30.6689 17.334C32.1409 17.334 33.3359 18.529 33.3359 20.001C33.3358 21.4728 32.1408 22.667 30.6689 22.667C29.1972 22.6668 28.0031 21.4727 28.0029 20.001C28.0029 18.5291 29.1971 17.3342 30.6689 17.334Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
